<template>
  <div class="customer-review">
    <v-text-field dense hide-details v-model="approvedByCode" outlined class="my-2" label="Test manager" style="max-width: 250px;"></v-text-field>
    <index-view title="Review cửa hàng" :filters="filters" :getData="getData" 
    :getDetail="getDetail" :headers="mainHeaders" :detailWidth="800" :cellSlots="cellSlots">
      <template #viewSection="{ item }">
        <detail :item="item" ></detail>
      </template>
      
      <template v-for="cellSlot in cellSlots" v-slot:[cellSlot]="{ cell, reload }">
        <span :class="cell[cellSlot]?.employeePositionStateCode == cell[cellSlot]?.type ? '' : 'grey--text text-lighten-2'"
        style="cursor: pointer;"
        v-if="cell[cellSlot]" :key="cellSlot" @click="dialog=true, selected = cell[cellSlot], indexReload = reload"> {{cell[cellSlot].score}} / {{cell[cellSlot].maxScore}}</span>
      </template>
    </index-view>

    <v-dialog v-model="dialog" width="1000" scrollable>
      <v-card class="rounded-lg">
        <v-card-title class="text-subtitle-1">
          Phiếu đánh giá
          <v-spacer></v-spacer>
          <v-btn color="red" icon @click="dialog=false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="primary--text">
          <v-row>
            <v-col cols="12">
              <strong>ID:</strong> {{ selected?.id }}
            </v-col>
            <v-col cols="12" md="6">
              <strong>Mã nhân viên:</strong> {{ selected?.employeeCode }}
            </v-col>
            <v-col cols="12" md="6">
              <strong>Tên nhân viên:</strong> {{ selected?.employeeName }}
            </v-col>
            <!-- <v-col cols="12" md="6">
              <strong>Thời gian từ:</strong> {{ $formatter.formatDate(selected?.validFrom, 'DD/MM/YYYY') }}
            </v-col>
            <v-col cols="12" md="6">
              <strong>Đến:</strong> {{ $formatter.formatDate(selected?.validTo, 'DD/MM/YYYY') }}
            </v-col> -->
            <v-col cols="12" md="6">
              <strong>Điểm:</strong> {{ selected?.score }} / {{ selected?.maxScore }}
            </v-col>
            <v-col cols="12" md="6" >
              <strong>Trạng thái:</strong> 
              <span class="ml-2 cyan--text" v-if="selected?.status === 0">Tạo mới</span>
              <span class="ml-2 green--text" v-else-if="selected?.status === 1">Lưu đánh giá</span>
              <span class="ml-2 red--text" v-else-if="selected?.status === 2">Hủy</span>
            </v-col>
          </v-row>
          <v-divider class="my-2"></v-divider>
          <v-data-table :items="selected?.employeeReviewDetails" :headers="viewHeaders">
            <template v-slot:item.score="{ item }">
              <v-icon v-if="item?.score" color="green" @click="setScore(item,false)">mdi-check</v-icon>
              <v-icon v-if="!item?.score" color="red" @click="setScore(item,true)">mdi-close</v-icon>
            </template>
            <template v-slot:item.conditionTitle="{ item }">
              <b >{{ item.conditionTitle }}</b>
              <p class="text--body-2">
                {{ item.conditionBody }}
              </p>
            </template>
          </v-data-table>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn  v-if="selected?.status===0" color="teal darken-4" dark style="text-transform: none;" @click="submitScore">Lưu đánh giá</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import IndexView from '../../../../components/CommonView/IndexView.vue';
import { get, getDetail, setScore, submitScore } from './api'
import { main, view } from './header'
import Detail from './Detail.vue'
const statusFilters = ['Tạo mới', 'Hoàn tất', 'Hủy']
export default {
  name: "ManagerEmployeeReview",
  components: {
    IndexView,
    Detail
  },
  computed: {
    mainHeaders () {
      return main(this.filters)
    },
    viewHeaders () {
      return view([])
    }
  },
  data() {
    return {
      filters: [
        {name: 'id', label:'Id', type: 'text', value: '' },
        {name: 'keyEmployeeCode', label:'Mã NS', type: 'text', value: '' },
        {name: 'keyEmployeeName', label:'Tên NS', type: 'text', value: '' },
      ],
      action1Dialog: false,
      cellSlots: ['month1', 'month2', 'month3', 'month4', 'month5', 'month6'],
      dialog: false,
      selected: null,
      indexReload: null,
      approvedByCode: ''
    }
  },
  methods: {
    getData() {
      return get(this.approvedByCode)
    },

    getDetail: getDetail,

    setScore(item, score) {
      return setScore(item.reviewId, item.conditionId, score).then(() =>{
        item.score = score
        this.selected.score = this.selected.score + (score ? 1 : -1)
        this.selected.status = 0
      }).finally(() => {
        console.log(this.indexReload)
        this.indexReload();
      })
    },

    submitScore() {
      return submitScore(this.selected.id).then(() => {
        this.dialog = false;
      }).finally(() => {
        this.indexReload();
      })
    }
  }
}
</script>